// Modules
import cn from 'classnames';

// Types
import type { TCardProps } from './Card.type';

// Styles
import styles from './styles.module.scss';

// Helpers
import { isString, snakeCase } from '../../helpers';

// Constants
import { CARD_DEFAULT_PROPS } from './Card.constant';

const Card = (props: TCardProps) => {
  const {
    bordered,
    children,
    className,
    elevation = CARD_DEFAULT_PROPS,
    noPadding,
    ...restProps
  } = props;
  const elevationCN = isString(elevation) ? snakeCase(elevation!) : snakeCase(CARD_DEFAULT_PROPS.elevation);

  const cardCN = cn(className, styles.legion_card, styles[elevationCN], {
    [styles.bordered]: bordered,
    [styles.no_padding]: noPadding
  });

  return (
    <div className={cardCN} {...restProps}>
      {children}
    </div>
  );
};

Card.displayName = 'Card';
export default Card;
